<app-form (submit)="updateInfo()">
    <div class="card">
        <div class="card-header">
            <h3 class="card-header-title">
                <app-connection-image
                        [connectionType]="data.entity.connection.info.connectionType"></app-connection-image>
                Meter information
            </h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12 col-md-6">
                    <app-form-field label="Label">
                        <input [(ngModel)]="details.label" type="text" class="form-control">
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="Meter type">
                        <app-select [(ngModel)]="details.type" [options]="meterTypes"
                                    [selectedFormatter]="meterTypeFormatter"></app-select>
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="Meter numbers" [renderOptional]="false">
                        <ng-container *ngFor="let m of details.meterNumbers; let i = index; trackBy: trackByIndex">
                            <input [(ngModel)]="details.meterNumbers[i]" type="text" class="form-control">
                        </ng-container>
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="Covered area">
                        <input [(ngModel)]="details.area" type="number" class="form-control">
                    </app-form-field>
                </div>
                <div *ngIf="appContext.isAdminOrIntermediary()" class="col-12 col-md-6">
                    <app-form-field label="Categories">
                        <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
                            <ng-container *ngIf="details.tags?.length">
                                <ng-container *ngFor="let tag of details.tags; let i = index; trackBy: trackByIndex">
                                    <button type="button" class="btn btn-info btn-sm d-inline-flex align-items-center gap-1 flex-shrink-0">
                                        <span [class.notranslate]="tag.category === 'custom'">
                                            {{ tag.category === 'custom' ? tag.customType : (tag.category | sentenceCase) }}
                                        </span>:<span class="notranslate">{{ tag.value }}</span>
                                        <span class="btn-close btn-close-white p-0 ms-1" aria-label="Remove" (click)="removeTag(details.tags, i)"></span>
                                    </button>
                                </ng-container>
                            </ng-container>
                            <button type="button" class="btn btn-outline-info btn-sm flex-shrink-0 ms-1" (click)="addTag()">
                                Add category
                            </button>
                        </div>
                        <div *ngFor="let tag of newTags; let i = index" class="mb-3">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <label class="form-label mb-0">Category</label>
                                <button type="button" class="btn-close ms-2" aria-label="Remove" (click)="removeTag(newTags, i)"></button>
                            </div>
                            <app-select [(ngModel)]="tag.category" [options]="categories" (ngModelChange)="onCategoryChange(tag)" placeholder="Select category" required>
                            </app-select>
                            <div *ngIf="tag.category === 'custom'" class="mt-2">
                                <label class="form-label">Custom category</label>
                                <input [(ngModel)]="tag.customType" type="text" class="form-control" placeholder="Custom category" required>
                            </div>
                            <div class="mt-2">
                                <label class="form-label">Value</label>
                                <input [(ngModel)]="tag.value" type="text" class="form-control" placeholder="Value" required>
                            </div>
                        </div>
                    </app-form-field>
                </div>
            </div>
        </div>

        <div class="card-footer">
            <div class="d-flex justify-content-between">
                <a class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                <button type="submit" class="btn btn-primary">Save changes</button>
            </div>
        </div>
    </div>
</app-form>